import { ApiUtils } from '@/utils/ApiUtils'
import { resetState } from '@/utils/Storage'

const initialState = ()=> {
  return  {
    quotations: [],
    type: '', // special_sale service
    url: 'quotations/user/requests',
    totalItems: 0,
    loading: false,
    nextPageUrl: null
  }
}

export default {
  namespaced: true,
  state: {
    quotations: [],
    type: '', // special_sale service
    url: 'quotations/user/requests',
    totalItems: 0,
    loading: false,
    nextPageUrl: null
  },
  mutations: {
    reset: (state) => {
      const s = initialState()
      resetState(state, s);
    },
    setType(state, payload) { // special_sale service
      state.type = payload
    },
    setQuotations(state, payload) {
      if (payload.isNextPage)
        state.quotations = [...state.quotations, ...payload.quotations]
      else
        state.quotations = payload.quotations
      state.nextPageUrl = payload.nextPageUrl
      state.totalItems = payload.total
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },
  actions: {
    async setType(ctx, payload) { // type: special_sale, service / query doQuery
      ctx.commit('setType', payload.type)
      ctx.commit('reset')
      const response = await ctx.dispatch('getData', {
        query: null,
        doQuery: false,
        isNextPage: false
      })
      return response
    },
    async getData(ctx, payload) { // query doQuery isNextPage
      if (!ctx.state.type) return
      let url = ''
      if (payload.isNextPage)
        url = ctx.state.nextPageUrl.split('/v1/')[1]
      else
        if (payload.doQuery)
          url =  `${ctx.state.url}?type=${ctx.state.type}&${payload.query}`
        else 
          url = `${ctx.state.url}?type=${ctx.state.type}`
      const defaultState = {
        quotations: [],
        total: 0,
        nextPageUrl: null,
        isNextPage: false
      }

      try {
        ctx.commit('setLoading', true)
        const request = await ApiUtils.makeGet(url)
        if (request.ok || request.code === 200 || request.code === 201) {
          const json = await request.json()

          const data = json.result.quotation_requests
          const newPayload = {
            isNextPage: payload.isNextPage || false,
            quotations: data.data,
            nextPageUrl: data.next_page_url,
            total: data.total
          }
          ctx.commit('setQuotations', newPayload)
          if (payload.isNextPage)
            newPayload.quotations = ctx.state.quotations
          return newPayload
        }
        return defaultState
      } catch (error) {

        return defaultState
      } finally {
        ctx.commit('setLoading', false)
      }
    }
  },
  getters: {
    loading: state => state.loading
  }
}
